import { componentText } from './i18n_utils';

// "R1" -> "Round 1" in the viewer's language; any other name passes through.
export const expandRoundName = (name) => {
  const match = /^R(\d+)$/.exec(name);
  if (!match) return name;

  const number = match[1];
  return componentText('round_selector.round', `Round ${number}`, { number });
};

// A round selector's formatLabel for the scorecard pickers. Module-level so
// the prop keeps its reference - an inline arrow is a new function on every
// render and re-renders the connected selector with it.
export const expandedRoundLabel = (round) => expandRoundName(round.name);

export const roundLabelWithDate = (round, roundDates) => {
  const date = roundDates?.[round.id];
  return date ? `${round.name} (${date})` : round.name;
};

// Map of round id -> formatted play_at date string
export const buildRoundDates = (roundList = []) =>
  roundList.reduce((acc, round) => {
    if (round.play_at) acc[round.id] = round.play_at;
    return acc;
  }, {});

// Shown by both round pickers (desktop dropdown, mobile modal) when the
// round-list refresh fails.
export const roundsFailedMessage = () =>
  componentText('round_selector.rounds_failed', "Couldn't load the rounds. Please try again.");
